import { Model } from '@vuex-orm/core';
import OutboundSyncLogAPI from '@/api/OutboundSyncLogAPI';

export default class OutboundSyncLog extends Model {
  public static entity = 'outboundSyncLog';

  public static fields() {
    return {
      id: this.attr(null),
      clientId: this.attr(null),
      clientName: this.string(''),
      triggerSource: this.string(''),
      triggeredByUserName: this.attr(null),
      payloadType: this.string(''),
      status: this.string(''),
      sentAt: this.attr(null),
    };
  }

  public static async getAll() {
    let allLogs;
    try {
      allLogs = await OutboundSyncLogAPI.getAll();
    } catch (e) {
      return Promise.reject(e);
    }
    this.create({ data: allLogs.data });
    return Promise.resolve();
  }

  public id!: string;
  public clientId!: number;
  public clientName!: string;
  public triggerSource!: string;
  public triggeredByUserName!: string | null;
  public payloadType!: string;
  public status!: string;
  public sentAt!: string;
}